export default [{
	titulo: 'Legislação',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/legislacao',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]